import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../../styled/scientColors"

export const FullScreenGridContainer = styled(FlexContainer)`
  height: 100%;
  width: 100%;
  background-color: ${SCIENT_COLORS.darkGray3};
`

export const FullScreenGridHeader = styled(FlexContainer)({
  margin: "3px 10px 3px 10px",
})
